import { connect } from 'react-redux';
import OwnerExecutiveOfficer from "../../../../components/admin/riaContacts/acordionSections/OwnerExecutiveOfficer";

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
  }
}

const OwnerExecutiveOfficerContainer = connect(mapStateToProps, {})(OwnerExecutiveOfficer)

export default OwnerExecutiveOfficerContainer;